export enum UserSyntheticRole {
  admin = 4,
  partnerOwner = 3.5,
  partner = 3,
  managerOwner = 2.5,
  manager = 2,
  user = 1,
  autoscaler = 0,
}
